module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../../ng-src/assets/font-awesome/fonts/fontawesome-webfont.eot
// module chunks = styles